import { j as a } from "../../../jsx-runtime-CQ7OqOhn.js";
import { FontAwesomeIcon as i } from "@fortawesome/react-fontawesome";
import "./Icon.utilities.js";
import { iconStyles as n } from "./Icon.styles.js";
import p from "../../../tailwindConfig/bclTwMerge.js";
const b = ({
  icon: t,
  className: o = "",
  color: r = "primary",
  ...e
}) => {
  const { base: s, variant: m } = n;
  return /* @__PURE__ */ a.jsx(
    i,
    {
      icon: t,
      className: p(s, o),
      style: m[r],
      ...e
    }
  );
};
export {
  b as default
};
